import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from "../../hooks/useTranslation";
import { makeStyles, Typography } from "../../index";
import { summarizeWorks } from "./utils/summarizeWorks";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        backgroundColor: theme.palette.light.background.paper,
        padding: theme.spacing(0, 1),
    },
    withIcon: {
        // アイコンに隠れないようにするためのpadding。
        paddingLeft: 28,
    },
    empty: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.palette.light.text.hint,
    },
    table: {
        width: '100%',
        borderSpacing: 0,
        userSelect: 'none',
    },
    shrink: {
        maxWidth: 100,
    },
}); });
/**
 * １行の高さ
 *
 * 表示行数の計算に用いる
 * defaultTheme.typography.minimum.lineHeight（※） 20px + テーブルセルの枠の高さ 2px
 * ※ number型でないため参照できない
 */
var LINE_HEIGHT = 20 + 2;
/**
 * ドリルサムネイルコンポーネント。
 */
export var WorkThumbnail = React.memo(function (props) {
    var _a;
    var contents = props.contents, withIcon = props.withIcon, height = props.height;
    var t = useTranslation().t;
    var _b = useMemo(function () {
        var maxLines = Math.floor(height / LINE_HEIGHT);
        var paddingTop = (height - maxLines * LINE_HEIGHT) / 2;
        try {
            var works = summarizeWorks(contents, maxLines);
            return {
                displayWorks: works,
                isEmpty: works.length === 0,
                hasError: false,
                outerStyle: { paddingTop: paddingTop },
            };
        }
        catch (error) {
            console.error('WorkThumbnail:', error);
            return { displayWorks: [], isEmpty: true, hasError: true };
        }
    }, [contents, height]), displayWorks = _b.displayWorks, isEmpty = _b.isEmpty, hasError = _b.hasError, outerStyle = _b.outerStyle;
    var classes = useStyles();
    var rootClassName = classNames(classes.root, (_a = {},
        _a[classes.withIcon] = withIcon && !isEmpty,
        _a[classes.empty] = isEmpty,
        _a));
    if (isEmpty || hasError) {
        return (React.createElement("div", { className: rootClassName },
            React.createElement(Typography, { variant: "minimum" }, hasError ? t('サムネイルでエラーが発生しました。') : t('ワークが選ばれていません。'))));
    }
    return (React.createElement("div", { className: rootClassName, style: outerStyle },
        React.createElement("table", { className: classes.table }, displayWorks.map(function (work) { return (React.createElement("tr", null,
            React.createElement("td", null,
                React.createElement(Typography, { variant: "minimum", noWrap: true }, work.displayDrillType)),
            React.createElement("td", { className: classes.shrink },
                React.createElement(Typography, { variant: "minimum", noWrap: true }, work.workName)),
            React.createElement("td", null,
                React.createElement(Typography, { variant: "minimum", noWrap: true, align: "right" }, work.other)))); }))));
});
